// Working-day calendar calculations (hari kerja = Senin–Jumat, skip hari libur).

function toDateOnly(d) {
  const x = d instanceof Date ? new Date(d.getTime()) : new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function isoKey(d) {
  return d.toISOString().slice(0, 10);
}

function isWorkingDay(d, liburSet) {
  const dow = d.getDay();
  if (dow === 0 || dow === 6) return false;
  return !liburSet.has(isoKey(d));
}

/**
 * Hitung deadline: tanggalLHP + jumlahHK hari kerja (skip weekend + hari libur).
 * Start counting from tanggalLHP + 1.
 * Returns ISO date string (YYYY-MM-DD).
 */
export function hitungDeadline(tanggalLHP, jumlahHK = 60, hariLiburArr = []) {
  if (!tanggalLHP) return null;
  const liburSet = new Set((hariLiburArr || []).map((h) => h.tanggal));
  const cursor = toDateOnly(tanggalLHP);
  cursor.setDate(cursor.getDate() + 1);
  let counted = 0;
  while (counted < jumlahHK) {
    if (isWorkingDay(cursor, liburSet)) {
      counted += 1;
      if (counted === jumlahHK) break;
    }
    cursor.setDate(cursor.getDate() + 1);
  }
  return isoKey(cursor);
}

/**
 * Sisa hari kerja antara today dan deadline (exclusive of today, inclusive of deadline).
 * Returns positive if deadline in the future, 0 if today, negative if past.
 */
export function sisaHariKerja(today, deadline, hariLiburArr = []) {
  if (!deadline) return 0;
  const liburSet = new Set((hariLiburArr || []).map((h) => h.tanggal));
  const t = toDateOnly(today);
  const d = toDateOnly(deadline);
  if (t.getTime() === d.getTime()) return 0;
  const future = d > t;
  const start = future ? t : d;
  const end = future ? d : t;
  const cursor = new Date(start);
  cursor.setDate(cursor.getDate() + 1);
  let count = 0;
  while (cursor <= end) {
    if (isWorkingDay(cursor, liburSet)) count += 1;
    cursor.setDate(cursor.getDate() + 1);
  }
  return future ? count : -count;
}

export function formatTanggalID(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function todayIso() {
  return isoKey(new Date());
}
